const RAW_NODE_ENV = process.env.NODE_ENV;
const RAW_PUBLIC_URL = process.env.PUBLIC_URL;
const RAW_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RAW_APP_API_PREFIX = process.env.REACT_APP_API_PREFIX;

const DEFAULT_PRODUCTION_API_URL = "";

export const NODE_ENV = RAW_NODE_ENV ?? "production";
export const PUBLIC_URL = RAW_PUBLIC_URL ?? "";
export const APP_BACKEND_URL = (
  RAW_APP_BACKEND_URL ??
  (NODE_ENV === "production" ? DEFAULT_PRODUCTION_API_URL : "")
).replace(/\/$/, "");
export const APP_API_PREFIX =
  typeof RAW_APP_API_PREFIX === "string" && RAW_APP_API_PREFIX.trim()
    ? RAW_APP_API_PREFIX.trim()
    : null;
